export const locationsCz = {
  locations: {
    'Others': 'Ostatní'
  }
};
